const { parseLanguage, localeManager } = require('@pcid/locale-utils');

function getLinks(locale = localeManager.getLocale()) {
	const language = parseLanguage(locale);
	const lang = language === 'fr' ? 'fr' : 'en_US';

	return {
		about: `https://lclcallcenters.my.site.com/pcid/s/?language=${lang}`,
		help: `https://lclcallcenters.my.site.com/pcid/s/?language=${lang}`,
		terms: `https://accounts.pcid.ca/terms?locale=${locale}`,
		privacy: `https://www.loblaw.ca/${language}/privacy.html`,
	};
}

module.exports = getLinks;
